import http from 'hub-http/clients/apiClient';
export default {
  FLOW: {
    fetch: flowId => {
      return http.get(`automationapps/v1/campaigns?flowId=${flowId}&flowSource=PLATFORM`).then(res => res.campaignGuids);
    },
    save: (flowId, campaignGuids) => {
      return http.post(`automationapps/v1/campaigns?flowId=${flowId}&flowSource=PLATFORM`, {
        data: {
          campaignGuids
        }
      });
    }
  },
  WORKFLOW: {
    fetch: assetId => {
      return http.get(`automation/v3/workflows/${assetId}/campaigns`);
    },
    save: (assetId, campaigns) => {
      return http.put(`automation/v3/workflows/${assetId}/campaigns`, {
        data: campaigns
      });
    }
  }
};